import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useRequestLocation from '../../../hooks/useRequestLocation';
import DefaultScans from '../totalScans/DefaultScans';
import PeriodScans from '../totalScans/PeriodScans';
import CompareScans from '../totalScans/CompareScans';
import UniqIcon from './svg/UniqIcon';
import useUrlParams from '../../../hooks/useUrlParams';
import UniqIconMePage from './svg/UniqIconMePage';

const UniqueUsers = () => {
  const [
    uniq
    // setUniq
  ] = useState(0);
  const {
    // getTotalScans,
    getFilteredTotalScans
  } = useRequestLocation();
  const [firstPeriod, setFirstPeriod] = useState(0);
  const [secondPeriod, setSecondPeriod] = useState(0);

  const {
    mode,
    periodStart,
    periodEnd,
    secondPeriodStart,
    secondPeriodEnd,
    filters,
    page
  } = useSelector((state) => ({
    mode: state.filters.mode,
    periodStart: state.filters.periodStart,
    periodEnd: state.filters.periodEnd,
    secondPeriodStart: state.filters.secondPeriodStart,
    secondPeriodEnd: state.filters.secondPeriodEnd,
    filters: state.filters,
    page: state.meQrData.pagination.page
  }));
  const { t } = useTranslation();
  const { isMePage, isMeShortLinkPage } = useUrlParams();

  // TODO: Temporary hide total scans
  // useEffect(() => {
  //   let mounted = true;
  //   getTotalScans(true).then((data) => mounted && setUniq(data));
  //   return () => {
  //     mounted = false;
  //   };
  //   // eslint-disable-next-line
  // }, [filters.qrIds, page]);

  useEffect(() => {
    if (mode === 'period') {
      getFilteredTotalScans(periodStart, periodEnd, true).then((data) =>
        setFirstPeriod(data.filteredScans)
      );
    }
    if (mode === 'compare') {
      getFilteredTotalScans(secondPeriodStart, secondPeriodEnd, true).then(
        (data) => setSecondPeriod(data.filteredScans)
      );
      getFilteredTotalScans(periodStart, periodEnd, true).then((data) =>
        setFirstPeriod(data.filteredScans)
      );
    }
    // eslint-disable-next-line
  }, [mode, filters, page]);

  const uniqueScansText = isMePage
    ? t('mePage.unique')
    : isMeShortLinkPage
      ? t('meShortLink.uniqueClicks')
      : t('scans.unique');
  const uniqueDescriptionText = isMePage
    ? t('mePage.descriptionUniq')
    : isMeShortLinkPage
      ? t('meShortLink.descriptionUniq')
      : t('scans.descriptionUniq');
  const Icon = isMePage ? UniqIconMePage : UniqIcon;

  return (
    <Col xs={12} lg={6}>
      <div className="p-3 p-lg-4 bg-white h-100 rounded">
        <Row className="justify-content-between">
          <Col xs={8} xl={7}>
            <div className="fw-bold fs-4 mb-2 text-capitalize">
              {uniqueScansText}
            </div>
            <div className="text-gray fs-7 mb-3 mb-lg-4">
              {uniqueDescriptionText}
            </div>
          </Col>
          <Col
            xs={4}
            lg={3}
            className="d-flex justify-content-end align-items-start mt-4 mt-lg-0"
          >
            <Icon />
          </Col>
        </Row>
        {mode === 'default' && <DefaultScans scans={uniq} />}
        {mode === 'period' && <PeriodScans scans={firstPeriod} total={uniq} />}
        {mode === 'compare' && (
          <CompareScans firstPeriod={firstPeriod} secondPeriod={secondPeriod} />
        )}
      </div>
    </Col>
  );
};

export default UniqueUsers;
